import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-171d6953"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "chat-btn__badge" }, null, -1))

import {
  IonToolbar,
  IonButtons,
  IonButton,
  IonIcon,
  IonTitle,
  isPlatform
} from "@ionic/vue";
import { withDefaults } from "vue";
import { ellipsisVertical } from "ionicons/icons";
import useRoles from "@/hooks/useRole";
import { RoleEnum } from "@/generated/graphql";


const __default__ = {
  name: "page-header",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    transparent: { type: Boolean, default: false },
    buttonsTransparent: { type: Boolean, default: false },
    backBtn: { type: Boolean, default: false },
    skipBtn: { type: Boolean, default: false },
    closeBtn: { type: Boolean, default: false },
    scanBtn: { type: Boolean, default: false },
    chatBtn: { type: Boolean, default: false },
    moreBtn: { type: Boolean, default: false },
    title: { default: null },
    titleClass: { default: "header__title" },
    editBtn: { type: Boolean, default: false }
  },
  emits: ["back", "skip", "scan", "chat-click", "more-click", "edit-click"],
  setup(__props: any, { emit: emits }) {

const { role } = useRoles();




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonToolbar), {
    class: _normalizeClass(["header", {
      'header--transparent': _ctx.transparent,
      'header--buttons-transparent': _ctx.buttonsTransparent,
      'ios-app-top': _unref(isPlatform)('ios'),
      'user-header': _unref(role) === _unref(RoleEnum).User
    }])
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonButtons), {
        class: "start-buttons",
        slot: "start"
      }, {
        default: _withCtx(() => [
          (_ctx.backBtn)
            ? (_openBlock(), _createBlock(_unref(IonButton), {
                key: 0,
                class: "back-btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('back')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), { src: "assets/icon/arrow-back.svg" })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.closeBtn)
            ? (_openBlock(), _createBlock(_unref(IonButton), {
                key: 1,
                class: "close-btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('back')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), { src: "assets/icon/close.svg" })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.scanBtn)
            ? (_openBlock(), _createBlock(_unref(IonButton), {
                key: 2,
                class: "back-btn",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('scan')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), { src: "assets/icon/scan.svg" })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "avatar-field")
        ]),
        _: 3
      }),
      _createVNode(_unref(IonButtons), { slot: "end" }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "custom-btn"),
          (_ctx.skipBtn)
            ? (_openBlock(), _createBlock(_unref(IonButton), {
                key: 0,
                fill: "clear",
                color: "medium",
                class: "skip-btn",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (emits('skip')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Skip ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.chatBtn)
            ? (_openBlock(), _createBlock(_unref(IonButton), {
                key: 1,
                class: "chat-btn",
                shape: "round",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (emits('chat-click')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), { src: "assets/icon/chat.svg" }),
                  _hoisted_1
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.moreBtn)
            ? (_openBlock(), _createBlock(_unref(IonButton), {
                key: 2,
                class: "chat-btn",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('more-click')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), { icon: _unref(ellipsisVertical) }, null, 8, ["icon"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.editBtn)
            ? (_openBlock(), _createBlock(_unref(IonButton), {
                key: 3,
                class: "chat-btn",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('edit-click')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    slot: "icon-only",
                    src: "assets/icon/pencil.svg"
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 3
      }),
      _createVNode(_unref(IonTitle), {
        class: _normalizeClass(_ctx.titleClass)
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.title), 1)
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})